import IconClose from '~icons/mdi/close';
import React, { ReactElement, FunctionComponent } from 'react';
import { Dialog, Button, Box } from '@mui/material';
import { Centered } from './centered';
import styled from '@emotion/styled';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';

export interface CompProps {
  open: boolean;
  onClose: VoidFunction;
  competencyDescription: string;
}

// const mapStateToProps = (state: State): StateProps => ({});

// interface CompState {}

// const mapDispatchToProps = {};

type Props = CompProps;

export const CompetencyDialog: FunctionComponent<Props> = (
  props: Props
): ReactElement | null => {
  const { competencyDescription, onClose, open } = props;

  const CloseButton = styled(Button)`
    comment: 'Close Button';
    position: absolute;
    flex: 0 0 auto;
    display: flex;
    z-index: 200;
    flex-flow: row nowrap;
    align-self: flex-end;
    height: 30px;
    color: black;
    background-color: var(--Blue);
  `;

  return (
    <Dialog open={open} onClose={onClose} maxWidth={false}>
      <Box sx={{ padding: '0em', maxWidth: '800px' }}>
        <CloseButton onClick={() => onClose()}>
          <IconClose color={'black'} height={'1.5em'} width={'1.5em'} />
        </CloseButton>
        <Box sx={{ padding: '1em' }}>
          <Centered>
            <ReactMarkdown className='Intro'>
              {competencyDescription}
            </ReactMarkdown>
          </Centered>
        </Box>
      </Box>
    </Dialog>
  );
};
